import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  Box, Card, CardContent, CardHeader, Container, makeStyles, Divider, InputLabel,
  MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, Grid, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import PerfectScrollbar from 'react-perfect-scrollbar';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import { Formik } from 'formik';
import * as Yup from "yup";
import tokenService from '../../../../utils/tokenDecoder';
import authService from '../../../../utils/permissionAuth';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'DUECHEQUEDETAILS';

export default function DueChequeDetailsReport() {
  const classes = useStyles();
  const [title] = useState("Due Cheque Details Report");
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isBalanceRateChangeEnabled: false
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    selectedDate: new Date()
  });
  const [totalAmount, setTotalAmount] = useState({
    amount: 0
  });
  const componentRef = useRef();
  const alert = useAlert();

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    getFactoriesForDropDown();
  }, [selectedSearchValues.groupID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode === 'VIEWDUECHEQUEDETAILS');
    if (!isAuthorized) window.location.href = '/404';

    setPermissions({
      isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN'),
    });

    setSelectedSearchValues(prev => ({
      ...prev,
      groupID: parseInt(tokenService.getGroupIDFromToken()).toString(),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()).toString()
    }));
  }

  async function getGroupsForDropdown() {
    const result = await services.getAllGroups();
    setGroups(result);
  }

  async function getFactoriesForDropDown() {
    const result = await services.getFactoryByGroupID(selectedSearchValues.groupID);
    setFactories(result);
  }

  function calTotal(data) {
    let total = 0;
    data.forEach(element => {
      total += parseFloat(element.amount);
    });
    setTotalAmount({
      amount: total
    });
  }

  const GetDueChequeDetailsReports = async () => {
    const model = {
      groupID: parseInt(selectedSearchValues.groupID),
      factoryID: parseInt(selectedSearchValues.factoryID),
      selectedDate: selectedSearchValues.selectedDate.toISOString().split('T')[0]
    }
    let response = await services.GetDueChequeDetailsReports(model);
    if (response.statusCode == "Success" && response.data != null) {
      setTableData(response.data);
      calTotal(response.data);
      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
  };

  function generateDropDownMenu(data) {
    let items = [];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      });
    }
    return items;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setSelectedSearchValues(prev => ({ ...prev, [name]: value }));
    setTableData([]);
    setPage(0);
  }

  const handleDateChange = (date) => {
    if (!date) return;
    setSelectedSearchValues(prev => ({
      ...prev,
      selectedDate: date
    }));
    setTableData([]);
    setPage(0);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>{titleName}</Grid>
      </Grid>
    );
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Voucher Number': x.voucherNumber,
          'Cheque Number': x.chequeNumber,
          'Issuing Date': x.issuingDate.split('T')[0],
          'Due Date': x.dueDate.split('T')[0],
          'Account': x.account,
          'Recipient': x.recipient,
          'Amount': Number(x.amount)
        }
        res.push(vr);
      });
      res.push({});
      var vr = {
        'Voucher Number': 'Total Amount :',
        'Amount': Number(totalAmount.amount)
      }
      res.push(vr);
      res.push({});
      var vr = {
        'Voucher Number': 'Group Name :' + groups[selectedSearchValues.groupID],
        'Issuing Date': 'Factory Name :' + factories[selectedSearchValues.factoryID],
      }
      res.push(vr);
      var vr = {
        'Voucher Number': 'Date : ' + moment(selectedSearchValues.selectedDate).format('DD/MM/YYYY')
      }
      res.push(vr);
    }
    return res;
  }
  async function createFile() {
    const file = await createDataForExcel(tableData);
    const settings = {
      sheetName: 'Due Cheque Details Report',
      fileName:
        'Due Cheque Details Report - ' + groups[selectedSearchValues.groupID] + ' - ' + factories[selectedSearchValues.factoryID] + ' - ' + selectedSearchValues.selectedDate,
      writeOptions: {}
    };
    const keys = file.length > 0 ? Object.keys(file[0]) : [];
    let tempcsvHeaders = [];
    keys.forEach(sitem => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    SetCsvHeaders(tempcsvHeaders);
    const dataA = [{
      sheet: 'Due Cheque Details Report',
      columns: tempcsvHeaders,
      content: file
    }];
    xlsx(dataA, settings);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
            layout:portrait
        }
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: selectedSearchValues.groupID,
              factoryID: selectedSearchValues.factoryID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
              factoryID: Yup.number().required('Estate is required').min("1", 'Estate is required')
            })}
            onSubmit={GetDueChequeDetailsReports}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched, values, setFieldTouched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.groupID}
                              variant="outlined"
                              id="groupID"
                              size='small'
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">Factory *</InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="selectedDate" style={{ marginBottom: '-8px' }}>Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                autoOk
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="selectedDate"
                                name="selectedDate"
                                value={selectedSearchValues.selectedDate}
                                onChange={selectedDate => {
                                  handleDateChange(selectedDate);
                                  setFieldTouched('selectedDate', true, false);
                                }}
                                error={Boolean(touched.selectedDate && errors.selectedDate)}
                                helperText={touched.selectedDate && errors.selectedDate}
                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                        <br />
                        <Box minWidth={1050}>
                          {tableData.length > 0 ? (
                            <Box>
                              <TableContainer>
                                <Table aria-label="caption table" size='small'>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Voucher Number</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Cheque Number</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Issuing Date</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Due Date</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Account</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Recipient</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Amount (Rs.)</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                      <TableRow key={index}>
                                        <TableCell align="left" style={{ border: "1px solid black" }}>{row.voucherNumber}</TableCell>
                                        <TableCell align="left" style={{ border: "1px solid black" }}>{row.chequeNumber}</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" }}>{row.issuingDate ? row.issuingDate.substring(0, 10) : ""}</TableCell>
                                        <TableCell align="center" style={{ border: "1px solid black" }}>{row.dueDate ? row.dueDate.substring(0, 10) : ""}</TableCell>
                                        <TableCell align="left" style={{ border: "1px solid black" }}>{row.account}</TableCell>
                                        <TableCell align="left" style={{ border: "1px solid black" }}>{row.recipient}</TableCell>
                                        <TableCell align="right" style={{ border: "1px solid black" }}>{row.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      </TableRow>
                                    ))}
                                    <TableRow style={{ border: "2px solid black" }}>
                                      <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', paddingRight: '2%', width: '80%' }} colSpan={6}  >
                                        Total
                                      </TableCell>
                                      <TableCell align="right" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px' }} >
                                        {Number(totalAmount.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                                <TablePagination
                                  rowsPerPageOptions={[5, 10, 20]}
                                  component="div"
                                  count={tableData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onChangePage={handleChangePage}
                                  onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                              </TableContainer>
                              <Box display="flex" justifyContent="flex-end" p={2}>
                                <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="button"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorRecord}
                                  onClick={createFile}
                                  size="small"
                                >
                                  EXCEL
                                </Button>
                                <ReactToPrint
                                  documentTitle={'Due Cheque Details Report' + ' - ' + groups[selectedSearchValues.groupID] + ' - ' + factories[selectedSearchValues.factoryID] + ' - ' + (new Date(selectedSearchValues.selectedDate)).toLocaleDateString()}
                                  trigger={() => (
                                    <Button
                                      color="primary"
                                      id="btnCancel"
                                      variant="contained"
                                      style={{ marginRight: '1rem' }}
                                      className={classes.colorCancel}
                                      size="small"
                                    >
                                      PDF
                                    </Button>
                                  )}
                                  pageStyle={getPageMargins()}
                                  content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                  <CreatePDF
                                    ref={componentRef}
                                    tableData={tableData}
                                    selectedSearchValues={{
                                      ...selectedSearchValues,
                                      groupName: groups[selectedSearchValues.groupID],
                                      factoryName: factories[selectedSearchValues.factoryID]
                                    }}
                                    TotalAmount={totalAmount}
                                  />
                                </div>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
